import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const MarkdownContent = ({ content, className = "" }) => {
  return (
    <div className={`prose prose-sm max-w-none markdown-container ${className}`}>
      <ReactMarkdown 
        remarkPlugins={[remarkGfm]}
        components={{
          h1: ({node, ...props}) => <h1 className="text-xl font-bold border-b border-gray-300 dark:border-gray-600 pb-1 mb-2 text-gray-900 dark:text-gray-100" {...props} />,
          h2: ({node, ...props}) => <h2 className="text-lg font-bold mb-2 text-gray-900 dark:text-gray-100" {...props} />,
          h3: ({node, ...props}) => <h3 className="text-md font-bold mb-1 text-gray-900 dark:text-gray-100" {...props} />,
          ul: ({node, ...props}) => <ul className="list-disc ml-4 mb-2" {...props} />,
          ol: ({node, ...props}) => <ol className="list-decimal ml-4 mb-2" {...props} />,
          a: ({node, ...props}) => {
            const isMention = typeof props.children === 'string' && props.children.startsWith('@');
            if (isMention) {
              return (
                <span className="bg-blue-100 dark:bg-blue-900 text-primary-blue dark:text-blue-300 px-1 rounded font-semibold cursor-default">
                  {props.children}
                </span>
              );
            }
            return <a className="text-primary-blue dark:text-blue-400 hover:underline" target="_blank" rel="noreferrer" {...props} />;
          },
          table: ({node, ...props}) => (
            <div className="my-3 overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700">
              <table className="w-full border-collapse text-xs" {...props} />
            </div>
          ),
          thead: ({node, ...props}) => <thead className="bg-primary-blue text-white" {...props} />,
          th: ({node, ...props}) => <th className="text-left font-black uppercase tracking-widest text-[10px] px-3 py-2 border-b border-primary-blue" {...props} />,
          tbody: ({node, ...props}) => <tbody className="divide-y divide-gray-100 dark:divide-gray-700" {...props} />,
          tr: ({node, ...props}) => <tr className="even:bg-gray-50 dark:even:bg-gray-800/40" {...props} />,
          td: ({node, ...props}) => <td className="px-3 py-2 align-top text-gray-800 dark:text-gray-200 tabular-nums" {...props} />,
          blockquote: ({node, ...props}) => <blockquote className="border-l-4 border-gray-200 dark:border-gray-700 pl-4 italic my-2 text-gray-700 dark:text-gray-300" {...props} />,
          code: ({node, ...props}) => <code className="bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-gray-100 rounded px-1 font-mono text-xs" {...props} />,
          p: ({node, ...props}) => <p className="mb-2 last:mb-0 text-gray-800 dark:text-gray-200" {...props} />,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownContent;